import { useLocation } from '@gatsbyjs/reach-router'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import React, { useEffect, useState } from 'react'
import CrossIcon from '../../assets/images/svg/cross.svg'
import HamburgerMenuIcon from '../../assets/images/svg/hamburger.svg'
import MessagesIconUnread from '../../assets/images/svg/messages-unread.svg'
import MessagesIconRead from '../../assets/images/svg/messages.svg'
import useAuth from '../../contexts/AuthContext/useAuth'
import { hasUnreadMessage } from '../../templates/message-center/data'
import Nav from '../Nav/Nav'
import Users from '../Users'
import { MenuButton, MenuContainer, MenuLink } from './HeaderNav.styled'

interface IProps {
  isNavOpen: boolean
  setIsNavOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const HeaderNav = ({ isNavOpen, setIsNavOpen }: IProps) => {
  const { pathname } = useLocation()
  const { t } = useTranslation()
  const { isAuthenticated } = useAuth()

  // const isGamePageOpen = allGames?.find((game) => pathname.includes(game.info.slug))
  const isAppTrialPage = pathname.includes('app-trial')

  const [showUnreadIcon, setShowUnreadIcon] = useState<boolean>(false)
  useEffect(() => {
    void (async () => {
      try {
        const hasUnread = await hasUnreadMessage()
        setShowUnreadIcon(hasUnread)
      } catch {}
    })()
  }, [])

  const Icon = showUnreadIcon ? MessagesIconUnread : MessagesIconRead

  return (
    <>
      <MenuContainer
        style={{
          alignSelf: 'center',
          justifyContent: 'center',
          alignItems: 'baseline',
        }}
      >
        <Users
          isNavOpen={isNavOpen || isAppTrialPage}
          setIsNavOpen={setIsNavOpen}
        />

        {isAuthenticated && (
          <MenuLink
            to='/messages'
            aria-label='Open messages'
            onClick={() => setIsNavOpen(false)}
          >
            <MenuButton
              isNavOpen={isNavOpen || isAppTrialPage}
              marker
              aria-haspopup='true'
              as={'div'}
            >
              <Icon />
              <p>Messages</p>
            </MenuButton>
          </MenuLink>
        )}

        <MenuButton
          isNavOpen={isNavOpen || isAppTrialPage}
          aria-haspopup='true'
          onClick={() => setIsNavOpen((prevState) => !prevState)}
          aria-label={
            isNavOpen ? t('aria.label.closeMenu') : t('aria.label.openMenu')
          }
        >
          {isNavOpen ? (
            <CrossIcon aria-hidden='true' />
          ) : (
            <HamburgerMenuIcon aria-hidden='true' />
          )}
          <p>{t('components.headerNav.menu')}</p>
        </MenuButton>
        <Nav isNavOpen={isNavOpen} setIsNavOpen={setIsNavOpen} />
      </MenuContainer>
    </>
  )
}

export default HeaderNav
